/**
 * @file Hero Act Now Animated Component.
 * Handles the word cycling animation for the hero title.
 */

import { gsap } from 'gsap';

/**
 * Hero Act Now Animated component.
 */
const vHeroActNowAnimated = () => {
	const heroActNowAnimated = document.querySelector('.v-hero-act-now-animated');

	if (
		!heroActNowAnimated ||
		!heroActNowAnimated.querySelectorAll('.v-hero-act-now-animated__word')
	) {
		return;
	}

	const mm = gsap.matchMedia();
	const line = heroActNowAnimated.querySelector(
		'.v-hero-act-now-animated__words-wrap',
	);
	const wrapper = heroActNowAnimated.querySelector(
		'.v-hero-act-now-animated__words',
	);
	const words = [
		...heroActNowAnimated.querySelectorAll('.v-hero-act-now-animated__word'),
	];

	mm.add(
		{
			isDesktop: '(min-width: 1200px)',
			isTablet: '(min-width: 768px) and (max-width: 1200px)',
			isMobile: '(max-width: 767px)',
		},
		(ctx) => {
			let bgOpacity = 0.59;
			const { isDesktop, isTablet, isMobile } = ctx.conditions; // eslint-disable-line
			const wordsTl = gsap.timeline({
				defaults: {
					ease: 'sine.out',
					duration: 1,
				},
				onComplete: () => {
					heroActNowAnimated.classList.add('finished');
					gsap.set(wrapper, { clearProps: 'y' });
				},
			});

			// any other setup
			if (isTablet) {
				bgOpacity = 0.55;
			} else if (isDesktop) {
				bgOpacity = 0.52;
			}

			wordsTl.addLabel('start', 0).to(line, { opacity: 1 }, 'start');

			// Set up the words scroll animation
			words.forEach((word, index) => {
				const offsetIndex = index + 1; // +1 to account for the empty word at the start
				const isLastWord = word.classList.contains(
					'v-hero-act-now-animated__word--last',
				);
				const visibleHeight = line.getBoundingClientRect().height;
				let yOffset = visibleHeight * -offsetIndex;

				if (isDesktop) {
					yOffset = isLastWord
						? yOffset - (word.getBoundingClientRect().height - visibleHeight)
						: yOffset;
				}

				wordsTl
					.to(wrapper, {
						y: yOffset,
					})
					.to(
						word,
						{
							opacity: 1,
							color: isLastWord ? 'var(--c-grace-contraston-dark)' : '#fff',
							onComplete: () => {
								word.setAttribute('data-active-offset', '0');
								gsap.set(word, { clearProps: 'opacity,color' });
							},
							onStart: () => {
								words
									.slice(index + 1)
									.forEach((w, i) =>
										w.setAttribute(
											'data-active-offset',
											`+${i > 2 ? 3 : i + 1}`,
										),
									);

								if (index === 0) {
									return;
								}

								words
									.slice(0, index)
									.forEach((w, i) =>
										w.setAttribute(
											'data-active-offset',
											`-${index - i > 3 ? 3 : index - i}`,
										),
									);
							},
						},
						'<',
					);
			});

			wordsTl.addLabel('wordsEnd');

			if (isDesktop) {
				wordsTl.to(
					words.filter(
						(w) => !w.classList.contains('v-hero-act-now-animated__word--last'),
					),
					{
						opacity: 0,
						duration: 0.3333,
					},
					'wordsEnd',
				);
			}

			wordsTl.to(
				'.v-hero-act-now-animated__background-image',
				{
					opacity: bgOpacity,
					duration: isDesktop ? 1 : 0.3333,
				},
				'wordsEnd',
			);

			if (isDesktop) {
				wordsTl.to(
					'.v-hero-act-now-animated__overlay',
					{
						opacity: 0,
						duration: 0.3333,
					},
					'wordsEnd',
				);
			}

			return () => {
				heroActNowAnimated.classList.remove('finished');
			};
		},
	);
};

export default vHeroActNowAnimated;
